import * as SystemActions from 'src/app/store/system/actions/system.actions';
import * as PortfoliosActions from './../actions/portfolios.actions';
import { initialPortfolioState, IPortfoliosState } from '../../state/portfolios.state';

export function portfoliosReducer(state = initialPortfolioState, action: PortfoliosActions.PortfoliosActions | SystemActions.SystemActions): IPortfoliosState {
  switch (action.type) {
    case PortfoliosActions.PortfoliosActionTypes.GET_INVESTOR_PORTFOLIOS:
      return {
        ...state,
        loading: true
      };
    case PortfoliosActions.PortfoliosActionTypes.GET_INVESTOR_PORTFOLIOS_SUCCESS:
      return {
        ...state,
        availablePortfolios: action.payload,
        loading: false
      };
    case PortfoliosActions.PortfoliosActionTypes.GET_INVESTOR_PORTFOLIOS_FAIL:
      return {
        ...state,
        loading: false
      };
    case PortfoliosActions.PortfoliosActionTypes.LOAD_PORTFOLIO_ENTITY_SUCCESS:
      return {
        ...state,
        selectedPortfolioEntity: action.payload
      };
      case PortfoliosActions.PortfoliosActionTypes.LOAD_PORTFOLIOS_FOR_ENTITIES_SUCCESS:
      return {
        ...state,
        entitiesPortfolios: action.payload
      };
    case PortfoliosActions.PortfoliosActionTypes.SEARCH_PORTFOLIOS_SUCCESS:
      return {
        ...state,
        searchPortfoliosResult: action.payload,
        loading: false
      };
    case PortfoliosActions.PortfoliosActionTypes.GET_REFERENCE_NUMBER:
      return {
        ...state,
        investorReferenceNumbers: {
          ...state.investorReferenceNumbers,
          [action.payload]: null
        }
      };
    case PortfoliosActions.PortfoliosActionTypes.GET_REFERENCE_NUMBER_SUCCESS:
      return {
        ...state,
        investorReferenceNumbers: {
          ...state.investorReferenceNumbers,
          [action.investorId]: action.referenceNumber
        }
      };
    case PortfoliosActions.PortfoliosActionTypes.GET_REFERENCE_NUMBER_FAIL:
      return {
        ...state,
        investorReferenceNumbers: {
          ...state.investorReferenceNumbers,
          [action.payload]: ''
        }
      };
    case SystemActions.CLEAR_SYSTEM:
      return initialPortfolioState;
    default:
      return state;
  }
}
